import axios from 'axios';

// 创建axios实例，设置配置得默认值
const instance = axios.create({
	// baseURL: 'http://192.168.31.221:18966/',   // 开发
	// baseURL: 'http://dongri.official.api.horzin.com/',   // 预发布
	baseURL: 'https://official.api.dongri.com/',   // 正式
	// baseURL: 'http://192.168.31.31:18966/',   // 天峰
	timeout: 20000,  // 设置请求超时的默认值 
})
// 设置请求拦截器
instance.interceptors.request.use(
	config => {
		
		return config
	},
	error => {
		// 请求错误进行拦截并返回错误信息
		return Promise.reject(error)
	}
)
// 设置响应拦截
instance.interceptors.response.use(
	res => {
		return res.data
	},
	error => {
		return Promise.reject(error)
	}	
)
// 向外暴露axios实例
export default instance
